import { h, Component } from 'preact';
import { showModal } from 'utils/modal';

import MediaSelectList from 'components/list/mediaSelectList';
import Button from 'components/button/button';

import s from 'components/media/mediaSelector.sss';

export default class MediaSelector extends Component {
	constructor(props) {
		super(props);
		this.onOpen = this.onOpen.bind(this);
		this.cancel = this.cancel.bind(this);
	}

	componentDidMount() {
		if (this.base.open) {
			this.onOpen();
		} else {
			this.base.addEventListener('toggle', this.onOpen, { once: true });
		}
	}

	onOpen() {
		// Ensure the upload manager is in front
		const openUploadManager = document.querySelector('#upload-manager:popover-open');
		if (openUploadManager) {
			openUploadManager.togglePopover(false);
			openUploadManager.togglePopover(true);
		}
	}

	cancel() {
		this.base.close('CANCEL');
	}

	render() {
		return (
			<dialog class={s.mediaSelector} id="media-selector">
				<Button class={s.close} icon="cancel" iconSize="large" onClick={this.cancel} />
				<MediaSelectList
					initialGroup={this.props.group}
					assetData={this.props.assetData}
					video={this.props.video}
					anyType={this.props.anyType}
				/>
			</dialog>
		);
	}
}

export async function showMediaSelector(options) {
	const data = await showModal(MediaSelector, options);
	if (!data || data === 'CANCEL') return data || null;
	try {
		return JSON.parse(data);
	} catch {}
	return null;
}